<template>
    <div class="min-h-screen flex flex-col bg-app">
        <Header :webConfig="webConfig"></Header>
        <main class="flex-grow text-body">
            <slot />
        </main>
        <Footer :webConfig="webConfig"></Footer>

    </div>
</template>

<script setup lang="ts">
import { computed, nextTick, watch } from 'vue';
import { WebConfig } from '@core/stores/types';
import { useAuthStore, useGeneralStore } from '@core/global';
import Header from '~/components/layout/Header.vue'
import Footer from '~/components/layout/Footer.vue'

const authStore = useAuthStore();
const generalStore = useGeneralStore();
const route = useRoute();

const webConfig = computed<WebConfig>(() => generalStore.webConfig);

const scrollToBody = () => {
    nextTick(() => {
        window.document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
};

watch(()=>route.path, (v2,v1)=>{
    if(v2 != v1) {
        scrollToBody();
    }
})
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.bg-app {
    background-color: rgb(var(--core-app-bg));
}
</style>
